import React, { useEffect, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import { useBranch } from '../../hooks/branches/useBranch';
import { useProductCategories } from '../../hooks/useProductCategories';
import { useInitialStockAdmin } from '../../hooks/inventory/initialStockAdmin/useInitialStockAdmin';
import InitialStockAdminFilters from '../../components/inventory/initialStockAdmin/InitialStockAdminFilters';
import InitialStockAdminTable from '../../components/inventory/initialStockAdmin/InitialStockAdminTable';
import InitialStockAdminEditPanel from '../../components/inventory/initialStockAdmin/InitialStockAdminEditPanel';

const InitialStockAdminPage: React.FC = () => {
  const { branchDropdown, fetchBranchDropdown } = useBranch();
  const { productCategoriesDropdown, fetchProductCategoriesDropdown } = useProductCategories();

  const {
    rows,
    paginator,
    isLoading,
    isSaving,
    selectedList,
    isSelected,
    toggleSelected,
    removeSelected,
    updateSelectedValue,
    clearSelected,
    search,
    saveOverride,
  } = useInitialStockAdmin();

  const [branchId, setBranchId] = useState<number | null>(null);
  const [term, setTerm] = useState('');
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [onlyNegative, setOnlyNegative] = useState(true);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  useEffect(() => {
    fetchBranchDropdown();
    fetchProductCategoriesDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    search({ branchId, term, categoryId, onlyNegative, page, size });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, term, categoryId, onlyNegative, page, size]);

  const handleFilterChange = (updater: () => void) => {
    setPage(0);
    updater();
  };

  const handleSave = async () => {
    const ok = await saveOverride();
    if (ok) {
      search({ branchId, term, categoryId, onlyNegative, page, size });
    }
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <div className="mb-5 rounded-sm border border-stroke bg-white p-5 shadow-default dark:border-strokedark dark:bg-boxdark">
        <h2 className="mb-1 text-lg font-semibold text-black dark:text-white">
          Corregir Inventario Inicial
        </h2>
        <p className="mb-4 text-sm text-body dark:text-bodydark2">
          Herramienta administrativa para ajustar manualmente la cantidad y el costo
          promedio de inventario de un producto cuando su existencia inicial quedó mal
          registrada (por ejemplo, productos vendidos que terminaron con stock negativo).
          Selecciona los productos a corregir y edítalos al final de la página.
        </p>

        <InitialStockAdminFilters
          branches={branchDropdown}
          categories={productCategoriesDropdown}
          branchId={branchId}
          term={term}
          categoryId={categoryId}
          onlyNegative={onlyNegative}
          onChangeBranch={(value) => handleFilterChange(() => setBranchId(value))}
          onChangeTerm={(value) => handleFilterChange(() => setTerm(value))}
          onChangeCategory={(value) => handleFilterChange(() => setCategoryId(value))}
          onChangeOnlyNegative={(value) => handleFilterChange(() => setOnlyNegative(value))}
        />
      </div>

      <div className="rounded-sm border border-stroke bg-white p-5 shadow-default dark:border-strokedark dark:bg-boxdark">
        <InitialStockAdminTable
          rows={rows}
          isLoading={isLoading}
          isSelected={isSelected}
          onToggle={toggleSelected}
          paginator={paginator}
          page={page}
          size={size}
          onPageChange={setPage}
          onSizeChange={(newSize) => {
            setSize(newSize);
            setPage(0);
          }}
        />
      </div>

      <InitialStockAdminEditPanel
        selected={selectedList}
        isSaving={isSaving}
        onChangeValue={updateSelectedValue}
        onRemove={removeSelected}
        onSave={handleSave}
        onClear={clearSelected}
      />
    </DefaultLayout>
  );
};

export default InitialStockAdminPage;
